import { graphql } from "~/gql";

export const UPDATE_FEE_EARNER_LEVELS = graphql(/* GraphQL */ `
  mutation updateFeeEarnerLevels($input: [UpdateManyFeeEarnerLevelsInput!]!) {
    updateFeeEarnerLevels(input: $input) {
      id
      order
      description
      externalReference
      restrictedGpmVisible
    }
  }
`);
